export const defaultConfigColunas = [
  { nome: "idLote", exibir: true },
  { nome: "observacao", exibir: true },
  { nome: "usuario", exibir: true },
  { nome: "aprovacao", exibir: true },
  { nome: "reciboNf", exibir: true },
  { nome: "beneficiario", exibir: true },
  { nome: "qtdProcessos", exibir: true },
  { nome: "custosDescricao", exibir: true },
  { nome: "totalAPagar", exibir: true },
  { nome: "valorCustos", exibir: true },
  { nome: "aReceber", exibir: true },
  { nome: "status", exibir: true },
  { nome: "dataPagamento", exibir: true },
];
